import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useTheme,
    Typography,
} from '@mui/material';
import MoneyRenderer from "../../../utils/MoneyRenderer";

function ArticlesOfFreeOrderConfirmationRequestTableComponent({ label, articles }) {
    const theme = useTheme();
    return (
        <Box
            sx={{
                maxHeight: 500,
                maxWidth: 1500,
                overflowX: 'auto',
                overflowY: 'auto',
                width: '100%',
            }}
        >
            {label && (
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {label}
                </Typography>
            )}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ minWidth: 180 }}>Código</TableCell>
                            <TableCell sx={{ minWidth: 250 }}>Nombre</TableCell>
                            <TableCell>Familia</TableCell>
                            <TableCell>Precio</TableCell>
                            <TableCell align="right">Cantidad</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {articles.map((article, index) => (
                            <TableRow key={index}>
                                <TableCell>{article.code}</TableCell>
                                <TableCell>{article.fantasyName}</TableCell>
                                <TableCell>{<article className="category"></article>}</TableCell>
                                <TableCell>
                                    {MoneyRenderer(0)}
                                </TableCell>
                                <TableCell align="right">
                                    {article.amount}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default ArticlesOfFreeOrderConfirmationRequestTableComponent;
